"use client";

import { ReactNode } from "react";

import { Button } from "@upstageai/ui";

import { Icon, Icons } from "../../../components/Icon";
import { BaseTooltip } from "../../../components/Tooltip/BaseTooltip";
import { cn } from "../../../utils/style";

export const ConfigSidebarDisabledInfoTooltip = ({
  children,
  showTooltip = true,
  className,
}: {
  children: ReactNode;
  showTooltip?: boolean;
  className?: string;
}) => {
  if (!showTooltip) return <>{children}</>;

  return (
    <BaseTooltip
      tooltipContent={
        <div className={cn(`${className} max-w-[230px]`)}>
          This option cannot be modified in the Playground. It can be configured
          when using the actual API.
        </div>
      }
      side="top"
    >
      {children}
    </BaseTooltip>
  );
};

export const ConfigSidebarCollapseButton = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  return (
    <Button size="icon" variant="ghost" className="-mr-1.5" onClick={onClose}>
      <Icon
        source={Icons.SidebarCollapse}
        className="size-4 text-muted-darker"
      />
    </Button>
  );
};

export const ConfigResetButton = ({
  onReset,
  disabled,
}: {
  onReset: () => void;
  disabled: boolean;
}) => {
  return (
    <Button
      size="xs"
      variant="ghost"
      className="gap-1"
      onClick={onReset}
      disabled={disabled}
    >
      <Icon source={Icons.Reset} className="size-4 text-muted-darker" />
      Reset to default
    </Button>
  );
};

export const ConfigApplyButton = ({
  onApply,
  disabled,
}: {
  onApply: () => void;
  disabled: boolean;
}) => {
  return (
    <Button
      size="sm"
      variant="ghost"
      className="text-secondary"
      onClick={onApply}
      disabled={disabled}
    >
      Apply
    </Button>
  );
};
